// Роли и права рабочего пространства Hub (окно «Настройки пользователей»). Проверка прав — на бэкенде (backend/hub/api/auth.py).

import type { Role } from "./auth";
import { t } from "@/lib/i18n";

export type WorkspaceUser = {
  id: string;
  name: string;
  email: string;
  role: Role;
  permissions: string[];
  status: "invited" | "active" | "disabled";
  owner: boolean;
  online: boolean;
  lastLoginAt?: string | null;
  lastSeenAt?: string | null;
  avatarUrl?: string | null;
};

export type AccessLevel = {
  id: Role;
  label: string;
  hint: string;
};

export const accessLevels: AccessLevel[] = [
  {
    id: "viewer",
    label: t("Наблюдатель"),
    hint: t("Наблюдатель видит все диалоги, контакты и отчёты, но ничего не меняет и не пишет клиентам."),
  },
  {
    id: "agent",
    label: t("Агент"),
    hint: t("Агент видит только диалоги, назначенные ему, и отвечает клиентам. Настройки рабочего пространства ему недоступны."),
  },
  {
    id: "manager",
    label: t("Менеджер"),
    hint: t("Менеджеры имеют доступ ко всем разделам рабочего пространства, включая настройки. При этом они не могут приглашать или удалять других менеджеров и удалять каналы."),
  },
  {
    id: "admin",
    label: t("Администратор"),
    hint: t("Администратор управляет каналами, интеграциями, участниками и оплатой. Полный доступ ко всем настройкам рабочего пространства."),
  },
];

// дополнительные права в модальном окне (backend PERMISSIONS)
export const accessRestrictions = [
  {
    id: "billing",
    label: t("Доступ к оплате"),
    text: t("Может смотреть счета, тариф и историю платежей."),
  },
  {
    id: "channels",
    label: t("Управление каналами"),
    text: t("Может подключать, отключать и перенастраивать каналы."),
  },
  {
    id: "members",
    label: t("Управление участниками"),
    text: t("Менеджер с этим правом добавляет агентов и отзывает у них доступ."),
  },
  {
    id: "exports",
    label: t("Экспорт данных"),
    text: t("Может запрашивать выгрузку контактов и диалогов."),
  },
  {
    id: "finance",
    label: t("Финансы всех клиентов"),
    text: t("Видит выручку, долг и оплаты Zoho Books у любого клиента. Без права — только у своих клиентов."),
  },
];

// что умеет каждый уровень — подсказки под списком
export const userHints = [
  {
    icon: "ri-user-star-line",
    title: t("Один владелец"),
    text: t("Владельца нельзя отключить или сменить ему роль. Владельцы задаются на сервере (OWNER_EMAILS)."),
  },
  {
    icon: "ri-shield-keyhole-line",
    title: t("Доступ по уровню"),
    text: t("Уровень доступа определяет, что пользователь может делать в рабочем пространстве."),
  },
  {
    icon: "ri-google-fill",
    title: t("Вход через Google"),
    text: t("Письмо не отправляется: добавленный пользователь сразу входит через Google с этой почтой. Отозванный доступ закрывается мгновенно."),
  },
];